import { environment as proEnvironment } from "./environment.production";

/**
 * Contains the environment variables
 */
export const environment = {
  ...proEnvironment,
};
